module.exports = {
    // The application name, to be used when asking the configuration system for settings
    appName: 'SchoolUsageReportHost',
    // These applications are referenced by the project in an unbuilt state, and require babel to also be run over them
    childApplications: []
};



// WEBPACK FOOTER //
// ./containers/app/app-config.js